import {isNullOrUndefined} from 'util';
import * as ibantools from 'ibantools';
import {Directive, forwardRef, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';

const PROVIDER_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => IbanValidator),
    multi: true
};

export function validateIban(iban: string, countryCode?: string) {
    if (!isNullOrUndefined(iban) && iban.length) {
        if (ibantools.isValidIBAN(iban)) {
            /* If IBAN valid check country if defined */
            if (!!countryCode && !isIbanValidByCountry(iban, countryCode)) {
                return {'iban-country': {valid: false}};
            }
        } else {
            /* If IBAN broken try determinate problem */
            if (!!countryCode && !isIbanValidByLength(iban, countryCode)) {
                return {'iban-length': {valid: false}};
            }

            /* Shown invalid checksum error */
            return {'iban-checksum': {valid: false}};
        }
    }

    return null;
}

@Directive({
    selector: '[ibanValidator]',
    providers: [PROVIDER_VALIDATOR]
})
export class IbanValidator implements Validator {

    @Input('countryCode') countryCode: string;

    validate(c: AbstractControl) {
        return validateIban(c.value, this.countryCode);
    }
}

function isIbanValidByCountry(iban: string, countryCode: string): boolean {
    return ibantools.extractIBAN(iban).countryCode === countryCode;
}

function isIbanValidByLength(iban: string, countryCode: string): boolean {
    const countrySpec = ibantools.getCountrySpecifications()[countryCode];

    if (countrySpec) {
        let expectedCharCount: number = ibantools.getCountrySpecifications()[countryCode].chars;
        let actualCharCount: number = iban.replace(/\s/g, '').length;
        return expectedCharCount === actualCharCount;
    }

    return true;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validators/iban.validator.ts